import * as React from 'react';
import StyledDataGrid from 'shared/components/StyledDataGrid';
import {
  DataGridProProps,
  GRID_TREE_DATA_GROUPING_FIELD,
  GridColDef,
  GridSortModel,
} from '@mui/x-data-grid-pro';

interface Props {
  rows: Record<string, unknown>[];
  columns: GridColDef[];
  sortModel?: GridSortModel;
  pinnedLeft?: string[];
  // Tree mode (Campaign Overview): rows carry a path and expand in place.
  treeData?: boolean;
  getTreeDataPath?: DataGridProProps['getTreeDataPath'];
  groupingColDef?: DataGridProProps['groupingColDef'];
}

// Compact-pivot grid: one column per metric (each cell renders all 4 windows),
// verdict/entity column pinned left. Rows auto-size so the verdict text never
// truncates — except in tree mode, where dynamic ('auto') row heights make the
// grid mis-measure rows with collapsed children (it reserves their space), so
// tree rows get fixed per-level heights instead (names line-clamp to fit).
export default function MetaDataGrid({
  rows,
  columns,
  sortModel,
  pinnedLeft,
  treeData,
  getTreeDataPath,
  groupingColDef,
}: Props) {
  const pinned = pinnedLeft ?? [treeData ? GRID_TREE_DATA_GROUPING_FIELD : 'entity'];
  return (
    <StyledDataGrid
      autoHeight
      getRowHeight={
        treeData
          ? p => ((p.model as { level?: string })?.level === 'campaign' ? 60 : 44)
          : () => 'auto'
      }
      columnHeaderHeight={40}
      rows={rows}
      columns={columns}
      treeData={treeData}
      getTreeDataPath={getTreeDataPath}
      groupingColDef={groupingColDef}
      disableRowSelectionOnClick
      hideFooter
      sx={{
        '& .MuiDataGrid-cell': { py: '6px', alignItems: 'flex-start' },
      }}
      initialState={{
        pinnedColumns: { left: pinned },
        ...(sortModel ? { sorting: { sortModel } } : {}),
      }}
    />
  );
}
